/**
 * Login script
 */
class ME_BTSFormRegister {
    constructor() {
        this.initState();
    }

    initState() {
        this.btsRegister = $('.back-to-school.register');
        this.btsRegisterForm = this.btsRegister.find('form.form');
        this.submitRegisterForm = this.btsRegisterForm.find('#register-button');

        if (!this.btsRegister.length) {
            return
        }

        this.initEvents();
    }

    initEvents() {
        let formHelper = new ME_FormHelper(this.btsRegisterForm);

        $('[data-answer-id]').parents('select').on('change', function (e) {
            $(this).find('option[data-answer-id]').each(function () {
                let id = $(this).attr('data-answer-id');
                $('[data-dependency-answer-id="' + id + '"]').addClass("is-hidden");
            });

            let selectedOption = $(this).find('option:selected');
            let answerId = selectedOption.attr('data-answer-id');
            if (answerId) {
                $('[data-dependency-answer-id="' + answerId + '"]').removeClass("is-hidden");
            }
        });

        $('[data-answer-id]').on('input change', function (e) {
            let $target = $(e.target);
            let answerId = $target.attr('data-answer-id');
            let shouldBeVisible = false;

            if ($target.is('input[type="checkbox"]')) {
                shouldBeVisible = $target.is(':checked');
            } else if ($target.is('input[type="radio"]')) {
                let radioName = $target.attr('name');

                $('input[type="radio"][name="' + radioName + '"]').each((i, el) => {
                    let id = $(el).attr('data-answer-id');
                    $('[data-dependency-answer-id="' + id + '"]').addClass("is-hidden");
                });

                shouldBeVisible = $target.is(':checked');
            }

            if (shouldBeVisible) {
                $('[data-dependency-answer-id="' + answerId + '"]').removeClass("is-hidden");
            } else {
                $('[data-dependency-answer-id="' + answerId + '"]').addClass("is-hidden");
            }
        });

        this.submitRegisterForm.on('click', e => {
            e.preventDefault();
            let result = formHelper.formValidate();
            var books_required = true;

            if ($('input[name="sectors[]"]:checked').length == 0) {
                let validationError = $('.sectors-header').find('.validation-error');
                validationError.removeClass('is-hidden');
                validationError.text('Pole jest wymagane');
            } else {
                $('input[name="sectors[]"]:checked').each(function () {
                    if ($(this).val() == 9) {
                        books_required = false;
                    }
                });
            }

            if (books_required && $('select[name="books[]"] option:selected').length == 0) {
                let validationError = $('.books-header').find('.validation-error');
                validationError.removeClass('is-hidden');
                validationError.text('Pole jest wymagane');
            } else {
                let validationError = $('.books-header').find('.validation-error');
                validationError.addClass('is-hidden');
                validationError.text('');
            }

            if (result) {
                if ($('.form-item.required-check .checkbox--radio:first-child input').is(':checked')) {
                    let dataHideAnswer = document.querySelectorAll('.form-item[data-dependency-answer-id]');
                    let allDivsHaveCheckedRadio = true;

                    dataHideAnswer.forEach(item => {
                        let inputs = item.querySelectorAll('input');
                        let isAnyRadioButtonChecked = false;

                        inputs.forEach(function (radioButton) {
                            if (radioButton.checked) {
                                isAnyRadioButtonChecked = true;
                            }
                        });

                        if (!isAnyRadioButtonChecked) {
                            allDivsHaveCheckedRadio = false;
                            let validationError = item.querySelector('.validation-error');
                            validationError.classList.remove('is-hidden');
                            validationError.textContent = 'Pole jest wymagane';
                        }

                        inputs.forEach(input => {
                            input.addEventListener('click', function () {
                                let validationError = item.querySelector('.validation-error');
                                validationError.classList.add('is-hidden');
                                validationError.textContent = '';
                            })
                        });
                    })

                    if (allDivsHaveCheckedRadio) {
                        this.btsRegisterForm.submit()
                    }
                } else {
                    this.btsRegisterForm.submit()
                }
            } else {
                let firstValidationError = $('.validation-error').not('.is-hidden').first();

                if (firstValidationError.length) {
                    $('html, body').animate({
                        scrollTop: firstValidationError.offset().top - 170
                    }, 1000);
                }
            }
        });
    }
}
